import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=575cff94"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"
import style0 from "./btn.vue?vue&type=style&index=0&id=575cff94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports